export var ComputeType;
(function (ComputeType) {
    ComputeType["CosmosVC"] = "CosmosVC";
    ComputeType["Synapse"] = "Synapse";
    ComputeType["BlueshiftADLA"] = "BlueshiftADLA";
})(ComputeType || (ComputeType = {}));
export var PlaceHolder;
(function (PlaceHolder) {
    PlaceHolder["ComputeName"] = "Lowercase alphanumeric, hyphen and underscore allowed.";
    PlaceHolder["ComputeNameAutoGenerated"] = "Name will be generated with Cluster and VC.";
    PlaceHolder["ComputeType"] = "Select compute resource type.";
    PlaceHolder["Cluster"] = "Cluster name. (e.g. cosmos09)";
    PlaceHolder["VCName"] = "VC name. (e.g. searchdmprod. Only lowercase letters are accepted.)";
    PlaceHolder["VCMaxConcurrentJobs"] = "This field allows users to set the maximum number of concurrent jobs allowed. This field should be set in consultatation with VC admins. Default value of 100.";
    PlaceHolder["Owners"] = "Enter owner alias";
    PlaceHolder["SubClusterName"] = "Alphanumeric, hyphen and underscore allowed.";
    PlaceHolder["KeyVaultURL"] = "Enter KeyVault URL";
    PlaceHolder["ClusterType"] = "";
    PlaceHolder["ClusterMaxConcurrentJobs"] = "";
    PlaceHolder["ClusterScale"] = "";
    PlaceHolder["ClusterRuntimeVersion"] = "Select Cluster runtime version";
    PlaceHolder["InstancePoolId"] = "Enter Instance Pool Id.";
    PlaceHolder["NodeType"] = "Enter Azure VM sku name";
    PlaceHolder["MinimumWorkersInCluster"] = "Minimum number of workers in cluster. Default 1.";
    PlaceHolder["MaximumWorkersInCluster"] = "Maximum number of workers in cluster. Default 1.";
    PlaceHolder["NumberOfWorkersInCluster"] = "Enter number of workers in cluster. Default 1.";
    PlaceHolder["DevelopmentUrl"] = "Enter Synapse URL.";
    PlaceHolder["StorageAccount"] = "Enter storage account name.";
    PlaceHolder["StorageContainer"] = "Enter storage account container name.";
    PlaceHolder["PoolName"] = "Enter spark pool name.";
    PlaceHolder["NodeSize"] = "Select executor size.";
    PlaceHolder["MinimumWorkersPerTask"] = "Minimum number of workers per task. Default 1.";
    PlaceHolder["MaximumWorkersPerTask"] = "Maximum number of workers per task. Default 1.";
    PlaceHolder["NumberOfWorkersPerTask"] = "Enter number of workers per task. Default 1.";
    PlaceHolder["ADLAAcount"] = "the acount name of ADLA(e.g. exptestblueshift)";
    PlaceHolder["DefaultStorageAccount"] = "Provide the default storage account of ADLA";
    PlaceHolder["ScorecardOutputStorageAccount"] = "Please select your output storage account";
    PlaceHolder["ServicePrincipalName"] = "Please select your principal";
    PlaceHolder["BlueshiftMaxConcurrentJobs"] = "This field allows users to set the maximum number of concurrent jobs allowed. This field should be set in consultatation with admins. Default value of 100.";
})(PlaceHolder || (PlaceHolder = {}));
export var AriaLabel;
(function (AriaLabel) {
    AriaLabel["ComputeName"] = "Name";
    AriaLabel["ComputeType"] = "Compute type";
    AriaLabel["Cluster"] = "Cluster";
    AriaLabel["VCName"] = "Virtual cluster name";
    AriaLabel["VCMaxConcurrentJobs"] = "Virtual cluster max concurrent jobs";
    AriaLabel["Owners"] = "Owners";
    AriaLabel["SubClusterName"] = "Name";
    AriaLabel["KeyVaultURL"] = "Key Vault URL";
    AriaLabel["ClusterType"] = "Cluster type";
    AriaLabel["ClusterMaxConcurrentJobs"] = "Cluster max concurrent jobs";
    AriaLabel["ClusterScale"] = "Cluster scale";
    AriaLabel["ClusterRuntimeVersion"] = "Cluster runtime version";
    AriaLabel["InstancePoolId"] = "Instance pool Id";
    AriaLabel["NodeType"] = "Node type";
    AriaLabel["MinimumWorkersInCluster"] = "Minimum workers in cluster";
    AriaLabel["MaximumWorkersInCluster"] = "Maximum workers in cluster";
    AriaLabel["NumberOfWorkersInCluster"] = "Number of workers in cluster";
    AriaLabel["DevelopmentUrl"] = "Synapse endpoint";
    AriaLabel["StorageAccount"] = "Default storage account name";
    AriaLabel["StorageContainer"] = "Default storage account container";
    AriaLabel["PoolName"] = "Spark pool name";
    AriaLabel["NodeSize"] = "Executor size";
    AriaLabel["MinimumWorkersPerTask"] = "Minimum workers per task";
    AriaLabel["MaximumWorkersPerTask"] = "Maximum workers per task";
    AriaLabel["NumberOfWorkersPerTask"] = "Number of workers per task";
    AriaLabel["ADLAAcount"] = "ADLA acount";
    AriaLabel["DefaultStorageAccount"] = "Default Storage Account";
    AriaLabel["ScorecardOutputStorageAccount"] = "Scorecard Output Storage Account";
    AriaLabel["ServicePrincipalName"] = "Service principal name";
    AriaLabel["BlueshiftMaxConcurrentJobs"] = "Blueshift ADLA max concurrent jobs";
})(AriaLabel || (AriaLabel = {}));

//# sourceMappingURL=ComputeAbstract.js.map
